// extracted by mini-css-extract-plugin
module.exports = {"ul":"List_ul__q5u8Z","ol":"List_ol__ROvth","waveAnimation":"List_waveAnimation__IuW2K","marquee":"List_marquee__lxREo"};